<template>
  <NotificationMessage :title="$t('newRelease.title')" :size="PopUpSize.Large" @close="hideModal">
    <ReleaseCarousel :new-release="newRelease" @complete-new-release="hideModal"></ReleaseCarousel>
  </NotificationMessage>
</template>

<script setup lang="ts">
import NotificationMessage from '@/components/common/NotificationMessage.vue';
import { PopUpSize } from '@/models/pop-up-size.enum';
import { UsersService } from '@/services/users.service';
import { useUserStore } from '@/stores/user';
import { FeatureReleaseModel } from '@onrunning/backstage-models';
import { ref } from 'vue';
import ReleaseCarousel from './release-carousel.vue';

export interface Props {
  featureRelease: FeatureReleaseModel | undefined;
}

const props = defineProps<Props>();
const emits = defineEmits(['hideModal']);

const usersService = new UsersService();
const userStore = useUserStore();

const newRelease = ref(props.featureRelease);
let isMarkedAsSeen = false;

const hideModal = () => {
  if (!isMarkedAsSeen && props.featureRelease?.externalId) {
    isMarkedAsSeen = true;
    usersService.updateRelease(props.featureRelease.externalId);
    if (userStore.userProfile?.user) {
      userStore.userProfile.user.lastSeenFeatureReleaseId = props.featureRelease.externalId;
    }
  }
  emits('hideModal');
};
</script>
